
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiHeavyRainShowersDayColour as ObiHeavyRainShowersDayColourElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-heavy-rain-showers-day-colour.js';
 
 
 

 
 export const ObiHeavyRainShowersDayColour = createComponent({
   react: React,
   tagName: 'obi-heavy-rain-showers-day-colour',
   elementClass: ObiHeavyRainShowersDayColourElement,
   events: {
     
   }
  });
 
 